import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Sort from './Sort';
import SimpleChart from './SimpleChart';
import moment from 'moment';
import {Link} from 'react-router-dom';
import Change from "./Change";
import {Desktop, LargeDesktop} from './Responsive';
import Price from './Price';

@observer
class CoinRows extends Component {
    constructor(props) {
        super(props);

        let favourites = [];
        try {
            favourites = JSON.parse(window.localStorage.favourites);
        } catch (err) {
            // Probably no favourites;
        }

        if (favourites.constructor !== Array) {
            favourites = [];
        }

        this.state = {
            favourites: favourites
        };

        this.generateCoin = this.generateCoin.bind(this);
        this.getCoins = this.getCoins.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);
        this.handleFavouriteClick = this.handleFavouriteClick.bind(this);
        this.isFavourite = this.isFavourite.bind(this);
        this.saveFavourites = this.saveFavourites.bind(this);
        this.addFavourite = this.addFavourite.bind(this);
    }

    handleRowClick(link) {
        let history = this.props.history;
        history.push(link);
    }

    handleFavouriteClick(symbol) {
        try {
            let favourites = this.state.favourites;
            let index = favourites.indexOf(symbol);
            if (index >= 0) {
                // Remove favourite
                favourites.splice(index, 1);
                this.saveFavourites(favourites);
            } else {
                // favourite doesn't exist, add it
                this.addFavourite(symbol);
            }
        } catch (err) {
            // Failed to handle favourite click...
        }
    }

    saveFavourites(newArray) {
        try {
            window.localStorage.favourites = JSON.stringify(newArray);
            this.setState({
                favourites: newArray
            });
        } catch (err) {

        }
    }

    isFavourite(symbol) {
        try {
            let favourites = this.state.favourites;
            let index = favourites.indexOf(symbol);
            return index >= 0;
        } catch (err) {
            return false;
        }

    }

    addFavourite(symbol) {
        try {
            let favourites = this.state.favourites;
            let newArray = [].concat(favourites);
            newArray.push(symbol);
            this.saveFavourites(newArray);
        } catch (err) {

        }
    };

    generateCoin(coin) {
        let appState = this.props.appState;
        let currency = appState.currency;
        let currencyPrefix = currency.prefix;
        let currencySuffix = currency.suffix;
        let currencyValue = appState.currency.value || 1.0;
        let coinData = {
            name: coin.name,
            symbol: coin.symbol,
            price: coin.price,
            rank: coin.rank,
            volume: coin.volume,
            cap: coin.cap,
            change: coin.change,
            updated: coin.updated,
            history: coin.history,
            historyCount: coin.count
        };

        let price = coinData.price;
        if (coinData.name === currency.name && currency.name === 'Bitcoin') {
            price = 1.0;
            currencyValue = 1.0;
        }

        let routingLink = "/coin/" + coinData.symbol;
        let lastUpdated = moment(coinData.updated).fromNow();


        let isFavourite = this.isFavourite(coinData.symbol);
        let favClass = "favourite-coin-disabled glyphicon-heart-empty";
        if (isFavourite) {
            favClass = "favourite-coin-enabled glyphicon-heart";
        }


        return (
            <tr id={coinData.symbol} key={coinData.name} className="cg-coin-row clickable" onClick={(e) => {
                let url = e.target.href;
                if (url) {
                    // Do nothing?
                } else if (e.target.classList.contains('no-click')) {
                    return null;
                } else {
                    this.handleRowClick(routingLink)
                }
            }}>
                <Desktop>
                    <td className="center no-underline rank">{ coinData.rank }</td>
                </Desktop>
                <Desktop>
                    <td className="center favourite-container no-click"
                        onClick={(e) => {
                            let symbol = coinData.symbol;
                            this.handleFavouriteClick(symbol);
                        }}
                    >
                        <i className={'favourite-coin glyphicon no-click ' + favClass}/>
                    </td>
                </Desktop>
                <Desktop>
                <td className="center cg-icon-row">
                    <span className={'cg-icon cg-icon-' + coinData.symbol.toUpperCase()} />
                </td>
                </Desktop>
                <td className="left name">
                    <Link to={routingLink}>
                        { coinData.name }
                        <span className="cg-label">{ coinData.symbol }</span>
                    </Link>
                </td>
                <td title={'Updated: ' + lastUpdated} className="right">{currencyPrefix}{ Price.format(price * currencyValue) }{currencySuffix}</td>
                <td className={'right'}><Change change={coinData.change}/></td>
                <Desktop>
                    <td className="center chart"><SimpleChart coinData={coinData} symbol={coinData.symbol}/></td>
                </Desktop>
                <LargeDesktop>
                    <td className="right" title={'Market cap: ' + currencyPrefix + Price.formatRound(coinData.cap * currencyValue, 2) + currencySuffix}>{currencyPrefix}{ Price.formatLargeNumber(coinData.cap * currencyValue, 2) }{currencySuffix}</td>
                </LargeDesktop>
                <LargeDesktop>
                    <td className="right volume" title={'Volume: ' + currencyPrefix + Price.formatRound(coinData.volume * currencyValue, 2) + currencySuffix}>{currencyPrefix}{ Price.formatLargeNumber(coinData.volume * currencyValue, 2) }{currencySuffix}</td>
                </LargeDesktop>



            </tr>
        )
    }

    getCoins() {
        let coins = this.props.coins;
        let searchQuery = this.props.appState.searchQuery;
        let favouriteCoins = [];
        let coinComponent = [];

        let filteredCoins = coins.filter(coin => {
            if (searchQuery.length === 0) {
                return true;
            }

            let coinName = coin.name.toLowerCase();
            let coinSymbolName = coin.symbol.toLowerCase();

            if (coinName.indexOf(searchQuery) >= 0) {
                return true;
            }

            if (coinSymbolName.indexOf(searchQuery) >= 0) {
                return true;
            }

            return false;
        });

        let compareFunc = Sort.compare(this.props.appState);
        filteredCoins.sort(compareFunc);

        for (let i = 0; i < filteredCoins.length; i++) {
            let coin = filteredCoins[i];

            if (this.isFavourite(coin.symbol)) {
                favouriteCoins.push(this.generateCoin(coin))
            } else {
                coinComponent.push(this.generateCoin(coin));
            }
        }

        if (favouriteCoins.length > 0) {
            favouriteCoins.push(
                <tr key="favourite-spacer" className="favourite-spacer">
                    <td colSpan={50}>
                        <div className="favourite-spacer-div"/>
                    </td>
                </tr>
            );
            favouriteCoins.push(
                <tr key="favourite-spacer-2" className="favourite-spacer">
                    <td colSpan={50}>
                        <div className="favourite-spacer-div"/>
                    </td>
                </tr>
            );
        }
        return favouriteCoins.concat(coinComponent);
    }

    render() {
        return (
            <tbody>
            { this.getCoins() }
            </tbody>
        );
    }
}

export default CoinRows;



// WEBPACK FOOTER //
// ./src/CoinRows.js